import React from 'react';
import { Tooltip as TooltipChakra } from '@chakra-ui/react';

interface TooltipProps {
  title: string;
  className?: string;
	children: JSX.Element;
}

const Tooltip: React.FC<TooltipProps> = ({
  title,
  children,
}) => {
  return (
		<TooltipChakra
			hasArrow
			label={title}
			placement='top'
			bg="red.900"
			borderRadius={6}
			px={4}
			py={1}
		>
			{children}
		</TooltipChakra>
    
  );
};

/*
<Container className={className}>
      {children}
      <span>{title}</span>
    </Container>
*/

export default Tooltip;
